module.exports = __webpack_public_path__ + "img/slider_galery_14.090fbce7.jpg";